// 檢查權限
import store from '@/store/index'
import { UserGettersTypes } from '@/store/modules/user'

// Permissions Item 權限項目
export enum PermissionsItem {
  reconciliations = 'reconciliations',
  branches = 'branches',
  merchants = 'merchants',
  orders = 'orders',
  products = 'products',
  vouchers = 'vouchers',
  any = 'any'
}

// Permissions Action 可執行操作
export enum PermissionsAction {
  create = 'create',
  read = 'read',
  update = 'update',
  delete = 'delete',
  any = 'any'
}

export interface PermissionType {
  create: boolean
  read: boolean
  update: boolean
  delete: boolean
}

/**
 * checkPermission
 * @param {string} item - 權限項目
 * @param {string} action - 可執行操作
 * @returns boolean => 有權限:true, 沒有權限:false
 */
export const checkPermission = (item: string, action: string): boolean => {
  const permissions = store.getters[UserGettersTypes.GET_PERMISSION]

  if (permissions[PermissionsItem.any]) {
    // any : any > 所有權限 & 所有動作
    if (permissions[PermissionsItem.any].includes(PermissionsAction.any)) {
      return true
    }
    // any : action > 所有權限 & 指定動作
    if (permissions[PermissionsItem.any].includes(action)) return true
  }

  if (permissions[item]) {
    // item : any > 指定權限 & 所有動作
    if (permissions[item].includes(PermissionsAction.any)) return true
    // item : action > 指定權限 & 指定動作
    if (permissions[item].includes(action)) return true
  }
  return false
}

/**
 * getPermissionByItem
 * @param {string} item - 權限項目
 * @returns obj : 該目錄的 CRUD權限
 */
export const getPermissionByItem = (item: string): PermissionType => {
  const object = {
    [PermissionsAction.create]: checkPermission(item, PermissionsAction.create),
    [PermissionsAction.read]: checkPermission(item, PermissionsAction.read),
    [PermissionsAction.update]: checkPermission(item, PermissionsAction.update),
    [PermissionsAction.delete]: checkPermission(item, PermissionsAction.delete)
  }
  return object
}

/**
 * 檢查是否有權限進入該頁面 (權限是否包含"指定的動作")
 * @param {string} authName - 權限名稱
 * @param {Array<string>} actions - 檢查權限要包含的動作
 * @returns {boolean}
 */
export const getPagePermission = (authName: string, actions: Array<string>): boolean => {
  const permissions = store.getters[UserGettersTypes.GET_PERMISSION]

  // any 權限
  if (permissions[PermissionsItem.any]) {
    // any : any > 所有權限 & 所有動作
    if (permissions[PermissionsItem.any].includes(PermissionsAction.any)) {
      return true
    }

    // any : actions > 所有權限 & 包含所有"指定"動作
    const anyPermissionHasEveryActions = actions.every((item) => permissions[PermissionsItem.any].includes(item))
    if (anyPermissionHasEveryActions) {
      return true
    }
  }

  // 指定權限
  if (permissions[authName]) {
    // authName : any > 指定權限 & 所有動作
    if (permissions[authName].includes(PermissionsAction.any)) {
      return true
    }

    // authName : actions > 指定權限 & 包含所有"指定"動作
    const permissionHasEveryActions = actions.every((item) => permissions[authName].includes(item))
    if (permissionHasEveryActions) {
      return true
    }
  }

  // 無權限
  return false
}
